<div class="main-container">

  <div class="title">
    <span class="title-text">My Profile</span>
    <p class="small-title">Update your contact number and email.</p>
  </div>

  <div class="cards">

    <!-- IDENTITY (read-only) -->
    <div class="card">
      <div class="card-title">Account</div>
      <div class="readonly-row"><span class="k">Name</span><span class="v">{{ profile.fullName || '-' }}</span></div>
      <div class="readonly-row"><span class="k">Username</span><span class="v">{{ profile.userName || '-' }}</span></div>
    </div>

    <!-- MOBILE (OTP) -->
    <div class="card">
      <div class="card-title">Mobile number</div>
      <div class="readonly-row"><span class="k">Current</span><span class="v">{{ profile.mobileNumber || '-' }}</span></div>

      @if(!otpStep){
      <div class="field">
        <span class="field-label">New mobile number</span>
        <input type="text" class="text-box-active" [formControl]="newMobile" />
      </div>
      <button type="button" class="ac-primary-btn" (click)="requestOtp()">Send OTP</button>
      } @else {
      <div class="field">
        <span class="field-label">Enter OTP sent to {{ newMobile.value }}</span>
        <input type="text" class="text-box-active" [formControl]="otp" />
      </div>
      <div class="row-actions">
        <button type="button" class="ac-secondary-btn" (click)="resetOtp()">Cancel</button>
        <button type="button" class="ac-primary-btn" (click)="verifyOtp()">Verify &amp; save</button>
      </div>
      }
    </div>

    <!-- EMAIL -->
    <div class="card">
      <div class="card-title">Email</div>
      <div class="field">
        <span class="field-label">Email</span>
        <input type="text" class="text-box-active" [formControl]="email" />
      </div>
      <button type="button" class="ac-primary-btn" (click)="saveEmail()">Save email</button>
    </div>

  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
